import { Preview } from "@mui/icons-material";
import axios from "axios";
import { call, put, take, takeLatest } from "redux-saga/effects";
import { generateNumRandomId } from "../../components/common/GenerateRandomId/GenerateRandomId";
import CustomMessage from "../../components/common/Snackbar/Snackbar";
import { axiosInstance } from "../../network/apis";
import { EMPLOYEE_CREATE_TICKET_REPLY_URL, EMPLOYEE_GET_TICKET_REPLY_URL, EMPLOYEE_UPDATE_TICKET_REPLY_URL, GET_CATEGORIES_EMPLOYEE_HELPDESK_URL, GET_EMPLOYEE_TICKETS_URL, GET_EMP_TICKET_URL, POST_CREATE_ATTACHMENT_URL, POST_CREATE_TICKET_EMPLOYEE_HELPDESK_URL, POST_DELETE_ATTACHMENT_URL, POST_DELETE_TICKET_REPLY_URL, POST_MARK_AS_RESOLVED_URL, POST_UPDATE_TICKET_STATUS_URL, UPLOAD_FILE_URL } from "../../network/apis/apiPath";
import { EMPLOYEE_HELPDESK_COMMENTS, EMPLOYEE_HELPDESK_PATH } from "../../utils/Constants";
import { getLocalStoreString } from "../../utils/Helper";
import { POST_CREATE_TICKET_REPLY, GET_EMPLOYEE_HELPDESK_CATEGORY, GET_EMPLOYEE_TICKETS, POST_GET_EMP_TICKET, POST_CREATE_TICKET_EMPLOYEE_HELPDESK, POST_UPDATE_TICKET_REPLY, POST_UPLOAD_FILE, POST_GET_TICKET_REPLY, POST_MARK_AS_RESOLVED, POST_DELETE_TICKET_REPLY, POST_UPDATE_TICKET_STATUS, POST_UPLOAD_FILE_CHAT, POST_CREATE_ATTACHMENT, POST_DELETE_ATTACHMENT, GET_TICKET_DATA } from "../type";
import { saveCategoriesEmployeeHelpdesk, saveGetEmployeeTickets, saveGetEmpTicket, saveReplyTicketData, saveUpdateReplyTicketData, saveGetReplyTicketData, saveGetTicketData } from "./employeeHelpDeskConfigSlice";

// const EmployeeID = getLocalStoreString('EmployeeId');
// const BearerToken = localStorage.getItem("BearerToken");
// const TenantId = getLocalStoreString("CompanyID");
// const randomId = generateNumRandomId(8);
// const Headers = {
//     'Authorization': `Bearer ${BearerToken}`,
//     'Accept': '*/*',
//     'content_type': 'image/png',
//     'employeeId': EmployeeID,
//     "companyId": TenantId,
//     'traceId': randomId
// };

function* postGetEmployeeGetTickets(action) {
    const { setLoader } = action;
    const EmployeeID = getLocalStoreString('EmployeeId');
    const BearerToken = localStorage.getItem("BearerToken");
    const TenantId = getLocalStoreString("CompanyID");
    const randomId = generateNumRandomId(8);
    const Headers = {
        'Authorization': `Bearer ${BearerToken}`,
        'Accept': '*/*',
        'content_type': 'image/png',
        'employeeId': EmployeeID,
        "companyId": TenantId,
        'traceId': randomId
    };
    const reqGetTickets = {
        traceId: randomId,
        employeeId: EmployeeID,
        companyId: TenantId,
    }
    try {
        const response = (yield call(axios.post, GET_EMPLOYEE_TICKETS_URL, reqGetTickets, { headers: Headers }))
        if (response.status == 200) {
            yield put(saveGetEmployeeTickets(response?.data?.tickets))
            setLoader(false)
        }
    } catch (error) {
        setLoader(false)
        console.log(error);
    }
}

function* getCategoriesEmployeeHelpdesk(action) {
    const { setLoader } = action
    try {
        const response = (yield call(axiosInstance.get, GET_CATEGORIES_EMPLOYEE_HELPDESK_URL))
        if (response) {
            yield put(saveCategoriesEmployeeHelpdesk(response?.data?.categories))
            setLoader(false)
        }
    } catch (error) {
        console.log(error);
        setLoader(false)
    }
}

function* postCreateTicketEmployeeHelpdesk(action) {
    const { payload, navigate, setLoader } = action;
    try {
        const response = (yield call(axiosInstance.post, POST_CREATE_TICKET_EMPLOYEE_HELPDESK_URL, payload))
        if (response) {
            navigate(EMPLOYEE_HELPDESK_PATH)
            setLoader(false)
        }
    } catch (error) {
        console.log(error);
        setLoader(false)
    }
}


function* postUploadFile(action) {
    const random_Id = generateNumRandomId(8)
    const { payload, setUploadFileData, uploadFileData, enqueueSnackbar, setLoader } = action;
    const { file } = payload;
    const formData = new FormData();
    formData.append("content_type", file?.type)
    formData.append('file', file);
    try {
        const response = (yield call(axiosInstance.post, UPLOAD_FILE_URL, formData))
        if (response?.status == 200) {
            const array = [...uploadFileData]
            const fileObject = {
                id: random_Id,
                attachmentUrl: response?.data?.url,
                attachmentType: file?.type,
            };
            array.push(fileObject)
            setUploadFileData(array)
            setLoader(false)
        }
    } catch (error) {
        console.log('error', error.response.data.message);
        const errorContent = error?.response?.data?.message;
        CustomMessage('File size cannot be more than 2MB.', "error", enqueueSnackbar);
        setLoader(false)
    }
}

function* postUploadFileChat(action) {
    const randomId = generateNumRandomId(8)
    const { payload, setInputImages, inputImages, setAttachmentImages, attachementImages, setSelectedImageModal, enqueueSnackbar } = action
    const { file } = payload;
    const formData = new FormData();
    formData.append("content_type", file?.type)
    formData.append('file', file);
    try {
        const response = (yield call(axiosInstance.post, UPLOAD_FILE_URL, formData))
        if (response.status === 200) {
            const arr = [...inputImages]
            const attahcmentArr = [...attachementImages]
            const fileObject = {
                id: randomId,
                attachmentUrl: response?.data?.url,
                attachmentType: file?.type,
            };
            arr.push(fileObject)
            attahcmentArr.push(fileObject)
            setAttachmentImages(attahcmentArr)
            setInputImages(arr)
            setSelectedImageModal(true)
        }
    } catch (error) {
        console.log('error', error.response.data.message);
        CustomMessage('File size cannot be more than 2MB.', "error", enqueueSnackbar);
    }
}

function* postGetEmpTicket(action) {
    const { payload } = action;
    try {
        const response = (yield call(axiosInstance.post, GET_EMP_TICKET_URL, payload))
        if (response?.status == 200) {
            yield put(saveGetEmpTicket(response?.data?.ticket))
        }
    } catch (error) {
        console.log(error);
    }
}

function* postEmployeeCreateTicketReply(action) {
    const { payload, UpdateReplyTicket, setSelectedImageModal } = action;
    try {
        const response = (yield call(axiosInstance.post, EMPLOYEE_CREATE_TICKET_REPLY_URL, payload))
        if (response) {
            yield put(saveReplyTicketData(response?.data?.ticket))
            UpdateReplyTicket()
            setSelectedImageModal(false)
        }
    } catch (error) {
        console.log(error);
    }
}

function* postEmployeeUpdateTicketReply(action) {
    const { payload, UpdateReplyTicket, setSelectedImageModal } = action;
    try {
        const response = (yield call(axiosInstance.post, EMPLOYEE_UPDATE_TICKET_REPLY_URL, payload))
        if (response) {
            yield put(saveUpdateReplyTicketData(response?.data?.ticket))
            UpdateReplyTicket()
            setSelectedImageModal(false)
        }
    } catch (error) {
        console.log(error);
    }
}
function* postEmployeeGetTicketReply(action) {
    const { payload } = action;
    try {
        const response = (yield call(axiosInstance.post, EMPLOYEE_GET_TICKET_REPLY_URL, payload))
        if (response) {
            yield put(saveGetReplyTicketData(response?.data?.ticket))
        }
    } catch (error) {
        console.log(error);
    }
}

function* postMarkAsResolved(action) {
    const { payload, UpdateReplyTicket } = action;
    try {
        const response = (yield call(axiosInstance.post, POST_UPDATE_TICKET_STATUS_URL, payload))
        if (response) {
            UpdateReplyTicket();
        }
    } catch (error) {
        console.log(error);
    }
}

function* postDeleteTicketReply(action) {
    const { payload, updateDeleteReply, setAttachmentImages } = action;
    try {
        const response = (yield call(axiosInstance.post, POST_DELETE_TICKET_REPLY_URL, payload))
        if (response?.status == 200) {
            updateDeleteReply()
            setAttachmentImages([])
        }
    } catch (error) {
        console.log(error);
    }
}

function* postCreateAttachment(action) {
    const { payload, setAttachmentImages } = action;
    try {
        const response = (yield call(axiosInstance.post, POST_CREATE_ATTACHMENT_URL, payload))
        if (response) {
            setAttachmentImages([])
        }
    } catch (error) {
        console.log(error);
    }
}

function* postDeleteAttachment(action) {
    const { payload, UpdateReplyTicket } = action;
    try {
        const response = (yield call(axiosInstance.post, POST_DELETE_ATTACHMENT_URL, payload))
        if (response) {
            UpdateReplyTicket()
        }
    } catch (error) {
        console.log(error);
    }
}

function* getTicketData(action) {
    const { payload } = action;
    yield put(saveGetTicketData(payload))
}


export function* employeeHelpdeskConfigWatcher() {
    yield takeLatest(GET_EMPLOYEE_HELPDESK_CATEGORY, getCategoriesEmployeeHelpdesk);
    yield takeLatest(POST_CREATE_TICKET_EMPLOYEE_HELPDESK, postCreateTicketEmployeeHelpdesk);
    yield takeLatest(GET_EMPLOYEE_TICKETS, postGetEmployeeGetTickets);
    yield takeLatest(POST_UPLOAD_FILE, postUploadFile);
    yield takeLatest(POST_CREATE_TICKET_REPLY, postEmployeeCreateTicketReply);
    yield takeLatest(POST_GET_EMP_TICKET, postGetEmpTicket);
    yield takeLatest(POST_UPDATE_TICKET_REPLY, postEmployeeUpdateTicketReply);
    yield takeLatest(POST_GET_TICKET_REPLY, postEmployeeGetTicketReply);
    yield takeLatest(POST_UPDATE_TICKET_STATUS, postMarkAsResolved);
    yield takeLatest(POST_DELETE_TICKET_REPLY, postDeleteTicketReply);
    yield takeLatest(POST_UPLOAD_FILE_CHAT, postUploadFileChat);
    yield takeLatest(POST_CREATE_ATTACHMENT, postCreateAttachment);
    yield takeLatest(POST_DELETE_ATTACHMENT, postDeleteAttachment);
    yield takeLatest(GET_TICKET_DATA, getTicketData);
}